import { c as _c } from "react/compiler-runtime";
import { IcoEyeCrossed16 } from '@onefootprint/icons';
import { Tooltip } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
const EmployeeOnlyIcon = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "deviceInsights"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoEyeCrossed16 color="tertiary" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <Tooltip content={t1}>{t2}</Tooltip>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default EmployeeOnlyIcon;
function _temp($) {
  return $.employeeOnly;
}